import React from 'react'
import {Select} from "antd"

const {Option} = Select

const MultiSelectSearch = (props) => {
    const {listSelect, name, value, label} = props

    const _handleChangeSelect = (value) => {
        props.onChange(name, value)
    }

    return (
        <div className="InputSearch CustomLineHeight">
            <label htmlFor={name}>{label}</label>

            <Select
                placeholder="Please select"
                mode="multiple"
                id={name}
                style={{width: '100%'}}
                defaultValue={value}
                onChange={_handleChangeSelect}
                showSearch
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                {
                    listSelect.map(item => {
                        return <Option value={item.value} key={item.value}>{item.name}</Option>
                    })
                }
            </Select>
        </div>
    )
}

export default MultiSelectSearch
